import React from "react";
import styles from './About.module.css';
import image from '../../Assests/Images/aboutInfoimage.png';

export function AboutInfoSection() {
  return (
    <section className={styles.aboutInfoSection}>
      <div className={styles.aboutInfoSectionContainer}>
        <div className={styles.aboutInfoSectionGrid}>
          {/* Left: Image */}
          <div className={styles.aboutInfoSectionImageWrapper}>
            <img
              src={image}
              alt="Supply Chain"
              className={styles.aboutInfoSectionImage}
            />
          </div>
          {/* Right: Text Content */}
          <div className={styles.aboutInfoSectionTextContent}>
            <h2 className={styles.aboutInfoSectionHeading}>Overview</h2>
            <div className={styles.aboutInfoSectionParagraph}>
              At Hyproc International, we don’t just manage supply chains we optimize them for success. With a global reach and local expertise, we provide tailored procurement and logistics solutions that keep industries moving forward. From oil & gas to manufacturing, utilities, and international aid, we deliver with precision, efficiency, and reliability.
            </div>
            <div className={styles.aboutInfoSectionParagraph}>
              Whether sourcing critical equipment or streamlining global logistics, we simplify the complexities so you can focus on what matters most: growing your business.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}